<template>
    <div>
		<div class="page-filter-box">
		    <el-row :gutter="20">				
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
					<el-input v-model="params.searchValue" class="input-with-select" size="small" placeholder="请输入渠道名称">
					</el-input>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.status" placeholder="请选择" size="small">
				        <el-option label="仅看启用的" :value="1"></el-option>
				        <el-option label="仅看禁用的" :value="0"></el-option>
						<el-option label="不限制状态" value=""></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.isSettlement" placeholder="请选择" size="small">
				        <el-option label="仅看涉及结算的" :value="1"></el-option>
				        <el-option label="仅看不涉及结算的" :value="0"></el-option>
						<el-option label="不限制是否涉及结算" value=""></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.suduSelectable" placeholder="请选择" size="small">
				        <el-option label="仅看可选的" :value="1"></el-option>
				        <el-option label="仅看不可选的" :value="0"></el-option>
						<el-option label="不限制经营平台是否可选" value=""></el-option>
				    </el-select>
				</el-col>
		        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
		            <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
		            <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
		        </el-col>
		    </el-row>
		</div>
        <div v-if="$utils.have('/thirdAccountManage/saveOrUpdate')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-plus" @click="$refs.edit.show()" size="small">新增渠道</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                    :data="dataList"
                    border
                    style="width: 100%"
                    v-loading="listLoading"
                    size="small"
                    stripe
                >
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="thirdName" label="渠道名称"></el-table-column>
                <el-table-column prop="source" label="Source"></el-table-column>
                <el-table-column prop="orderPrefix" label="订单前缀"></el-table-column>
				<el-table-column prop="isSettlement" label="是否涉及结算">
					<template slot-scope="scope">
						<span v-if="scope.row.isSettlement==0 ">不涉及</span>
						<span v-else-if="scope.row.isSettlement==1">涉及</span>
					</template>
				</el-table-column>
				<!-- 经营平台是否可选 -->
				<el-table-column prop="suduSelectable" label="经营平台是否可选" min-width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.suduSelectable==1" class="color-success">可选</span>
						<span v-else class="color-info">不可选</span>
					</template>
				</el-table-column>
				<el-table-column prop="serviceFee" label="默认服务费比例" min-width="100"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status" class="color-success">启用</span>
                        <span v-else class="color-info">禁用</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/thirdAccountManage/saveOrUpdate')"
                            type="text"
                            size="small"
                            @click="$refs.edit.show(scope.row)"
                            >管理</el-button
                        >
                        <el-button
                            type="text"
                            size="small"
                            @click="getToken(scope.row.token)"
                            >Token</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>

        <input class="copyTool" ref="copyTool" :value="token" />
        <Edit ref="edit" @onUpdate="getDataList"></Edit>
    </div>
</template>
<script>
import Edit from "./components/edit.vue"
const defaultParams = {
    pageNo: 1,
    status:'',
	isSettlement:'',
	searchValue:'',
	suduSelectable:''
}
export default {
    components:{Edit},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
            },
            listLoading: false,
            token: ""
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/thirdAccountManage/pageList",
                method: "POST",
                data: {
                    ...this.params
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //获取token
        getToken(data){
            this.$alert(data, 'Token', {
                confirmButtonText: "复制",
                callback: (e => {
                    if( e == "confirm"){
                        this.token = data;
                        this.copyToken();
                    }
                })
            })
        },
        //复制token
        copyToken(){
            clearTimeout(this.copyTimer);
            this.copyTimer = setTimeout(() => {
                const e = this.$refs.copyTool;
                e.select();
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.$message.success("已复制成功，可粘贴");
            },300)
        }
    }
}
</script>
<style lang="scss" scoped>
.copyTool{
    opacity: 0;
    filter: alpha(opacity=0);
    // height: 1px;
}
</style>